import React from 'react'
import './animationFooter.css'

const FooterAnimationUi = () => {
  return (
    <div className='aniMainBox'>
        <img src="https://images.leverageedu.com/homepage/flight.png" alt="Animation" />
        <div className='aniBox'> </div>
    </div>
  )
}

export default FooterAnimationUi